import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthInterceptor as OidcAuthInterceptor } from 'angular-auth-oidc-client';

@Injectable()
export class CustomAuthInterceptor extends OidcAuthInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.headers.has('X-Skip-Auth') && req.headers.get('X-Skip-Auth') === 'true') {
      const cleanReq = req.clone({ headers: req.headers.delete('X-Skip-Auth') });
      return next.handle(cleanReq);
    }
    return super.intercept(req, next);
  }
}
